<p-wrapper
  id="forgot-pwd"
  titleWrapper="Mot de passe oublié"
  [withPreviousButton]="true"
>
  <div body class="px-5">
    <form [formGroup]="forgotPassForm" (ngSubmit)="onForgotPass()">
      <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
        {{ errorMessage }}
      </div>

      <p-input
        [formControl]="this.forgotPassForm.controls.email"
        id="email"
        type="email"
        label="Email"
        name="email"
        description="Entrer votre email"
        errorMessage="Email obligatoire"
      ></p-input>
      <div class="d-flex justify-content-center">
        <p-button
          id="btn-reset-pwd"
          label="Réinitialiser le mot de passe"
          [width]="100"
          [disabled]="!forgotPassForm.valid"
          class="col-6 mt-4"
        ></p-button>
      </div>
    </form>
  </div>
</p-wrapper>
